import styled from "@emotion/styled";

export const FormLabelChild = styled("div")`
    min-width: 0;
`;
